import Role from 'models/core/role/Model.Role';
import Model from 'models/Model';
import StatementBalanceEmailTemplateAttachment from '../statementBalanceEmailTemplateAttachment/Model.StatementBalanceEmailTemplateAttachment';
import statementBalanceEmailTemplateDeleteApi from './delete/Api.StatementBalanceEmailTemplate.Delete';
import statementBalanceEmailTemplateListApi from './list/Api.StatementBalanceEmailTemplate.List';
import statementBalanceEmailTemplateSaveApi from './save/Api.StatementBalanceEmailTemplate.Save';

export default class StatementBalanceEmailTemplate
  extends Model<Model.IStatementBalanceEmailTemplate>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IStatementBalanceEmailTemplate>
{
  id: number;
  name: string;
  statementBalanceStatusTrigger: Model.Enum.StatementBalanceStatusCode;
  senderEmail: string;
  senderName: string;
  sendToRepresentative: boolean;
  sendToDealersAccounting: boolean;
  subject: string;
  htmlBody: string;
  recipientsWithRole?: Role[];
  additionalRecipientEmails: string[] = [];
  attachments?: StatementBalanceEmailTemplateAttachment[] = [];

  languageIsoCode?: Locale.Languages;
  readonly baseEntityId: number;

  constructor(
    data: Partial<Model.IStatementBalanceEmailTemplate> | Utils.FormData<Model.IStatementBalanceEmailTemplate>,
    language?: Locale.Languages
  ) {
    super(
      {
        recipientsWithRole: [Role],
        attachments: [StatementBalanceEmailTemplateAttachment],
      },
      language
    );
    this.update(data);
    if (!this.additionalRecipientEmails) this.additionalRecipientEmails = [];
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name,
      info: this.senderName,
      subtitle: this.senderEmail,
    };
  }
  static async list(body?: Api.Core.StatementBalanceEmailTemplate.List.IRequest) {
    const { payload, ...rest } = await statementBalanceEmailTemplateListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new StatementBalanceEmailTemplate(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await statementBalanceEmailTemplateSaveApi(this);
  }
  async delete() {
    return await statementBalanceEmailTemplateDeleteApi(this.id);
  }
}
